{
	"myShipments": "Mínar síður",
	"attentionRegistrationRequired": "Athugið, þetta er nýtt kerfi sem krefst innskráningar með rafrænum skilríkjum eða nýskráningar.",
	"companyLogin": "fyrir innskráningu fyrirtækja.",
	"VERIFY_SOCIALID": {
		"header": "Staðfesta kennitölu",
		"paragraph": "Sláðu inn netfangið sem notað var við nýskráningu",
		"success-header": "Staðfesting á kennitölu tókst!",
		"success-paragraph": "Þú getur núna skráð þig inn",
		"error-paragraph": "Upp kom villa við að staðfesta kennitölu - Við erum að skoða þetta!"
	},
	"VERIFY_EMAIL": {
		"header": "Staðfesta netfang",
		"paragraph": "Sláðu inn netfangið sem notað var við nýskráningu",
		"success-header": "Staðfesting á netfangi tókst!",
		"success-paragraph": "",
		"error-paragraph": "Upp kom villa við að staðfesta netfang - Við erum að skoða þetta!"
	},
	"RESET_PASSWORD": {
		"header": "Endurstilla lykilorð ",
		"email": "Netfang",
		"newPassword": "Nýtt lykilorð",
		"newPasswordAgain": "Nýtt lykilorð aftur",
		"success-header": "Breyting á lykilorði tókst!",
		"success-paragraph": "Þú getur núna skráð þig inn",
		"error-paragraph": "Upp kom villa við að breyta lykilorði - Við erum að skoða þetta!",
		"error-identical": "Lykilorðin verða að vera eins!"
	},
	"onboarding": {
		"profile": {
			"bubbleHeading": "Prófíll",
			"bubbleText": "Fylltu út nauðsynlegar upplýsingar",
			"infoText": "Vinsamlegast sláðu inn farsímanúmer svo við getum sent þér sms með upplýsingum um sendingarnar þínar",
			"emailVerified": "Netfang er staðfest",
			"emailNotVerified": "Netfang er ekki staðfest"
		},
		"payment": {
			"bubbleHeading": "Greiðsluleið",
			"bubbleText": "Veldu greiðsluleið",
			"heading": "Greiðslur",
			"infoText": "Einfaldaðu þér lífið með þvi að slá inn greiðslukort og skrá þig í sjálfvirkar greiðslur. Þá færðu sendingarnar fyrr í hendur.",
			"automaticPayments": "Skráðu þig í sjálfvirka greiðslu. Það flýtir afgreiðslu og þú borgar lægra umsýslugjald.",
			"automaticPaymentsCheckbox": "Velja sjálfvirka greiðslu"
		},
		"delivery": {
			"bubbleHeading": "Afhendingarstaður",
			"bubbleText": "Veldu hvert þú vilt fá sendingarnar þínar",
			"heading": "Afhendingarstaðir",
			"infoText": "Veldu afhendingarleið sem hentar þér vel í að fá pakka senda til þín."
		},
		"terms": {
			"bubbleHeading": "Skilmálar",
			"bubbleText": "Samþykktu skilmála um notkun",
			"heading": "Skilmálar",
			"terms1": "Til þess að geta notað mínar síður þarft þú að samþykkja ",
			"terms2": "almenna skilmála",
			"terms3": ". Þegar það er komið getur þú nýtt þér alla kosti minna síða.",
			"termsCheckbox": "Staðfesta skilmála"
		},
		"next": "Næsta skref",
		"skip": "Sleppa þessu skrefi",
		"complete": "Staðfesta"
	},
	"navigation": {
		"welcome": "Velkomin/n",
		"shipments": "Sendingar",
		"shipment": "Sending",
		"settings": "Mínar upplýsingar",
		"recipients": "Viðtakendur",
		"logout": "Útskráning",
		"refund": "Endurgreiðsla",
		"register-shipment": "Skrá sendingu"
	},
	"notifications": "Tilkynningar",
	"noNotifications": "Engar tilkynningar",
	"page-login": {
		"appPromotion": "Nýtt app komið fyrir bæði Android og Apple",
		"download": "Sækja",
		"fromGooglePlay": "í Google Play",
		"fromAppStore": "í App Store",
		"electronicId": "Rafræn skilríki",
		"electronicIdHeading": "Símanúmer",
		"electronicIdPlaceholder": "Sláðu inn símanúmer",
		"password": "Lykilorð",
		"retypePassword": "Endurtaka lykilorð",
		"enterEmail": "Sláðu inn netfang",
		"enterPassword": "Sláðu inn lykilorð",
		"logIn": "Skrá mig inn",
		"forgot-password": "Gleymt lykilorð?",
		"forgot-password-instructions": "Skráðu inn netfangið þitt og fáðu leiðbeiningar í vefpósti til að endurstilla lykilorðið. Athugið, þetta er nýtt kerfi og það þarf að skrá sig inn með rafrænum skilríkjum eða nýskrá sig til að logga sig inn.",
		"register": "Nýskráning",
		"registrationIntro": "Vinsamlegast fylltu út og staðfestu eftirfarandi upplýsingar",
		"iAccept": "Ég samþykki skilmála",
		"posturTerms": "Skilmálar Póstsins",
		"error": "Villa í innskráningu, vinsamlegast reyndu aftur",
		"registerButton": "Stofna aðgang að mínum síðum",
		"forgotPasswordIntro": "Skráðu inn netfangið þitt og fáðu leiðbeiningar í vefpósti til að endurstilla lykilorðið",
		"signupSuccessHeading": "Skráning tókst!",
		"signupSuccessHeadingSub": "Nú þarft þú að virkja aðganginn og tengja kennitöluna þína.",
		"signupSuccessStep1": "1. Farðu í pósthólfið og staðfestu netfangið þitt.",
		"signupSuccessStep2": "2. Þegar netfangið er staðfest þarf að fara í heimabanka og staðfesta kennitölu.",
		"signupSuccessStep3": "3. Þegar þetta tvennt er staðfest getur þú skráð þig inn með netfangi og lykilorði.",
		"socialIdVerificationMissing": "Kennitala er óstaðfest, vinsamlegast farið í rafræn skjöl í heimabanka og staðfestið kennitölu í skjali frá Póstinum.",
		"emailVerificationMissing": "Netfang er óstaðfest, vinsamlegast kíktu í innhólfið þitt og staðfestu netfangið í skilaboðum frá Póstinum",
		"invalidGrant": "Netfang eða lykilorð ekki rétt.",
		"loginFailed": "Auðkenning mistókst.",
		"phoneNumberNotCorrect": "Símanúmer er ekki rétt skráð",
		"user_fyrtaekjasidur": " ",
		"user_fyrtaekjasidur1": "Þetta er notendanafn fyrir ",
		"user_fyrtaekjasidur2": "Vinsamlegast notaðu rafræn skilríki eða notendanafn fyrir þína kennitölu ef þú ætlar að skrá þig inn á ",
		"user_fyrtaekjasidurLinkFyritaekjasidur": "Fyrirtækjasíður.  ",
		"user_fyrtaekjasidurLinkMinarSidur": "Mínar síður. ",
		"audkenni": {
			"audkenniApp": "Auðkennisapp",
			"verifyText": "Staðfestu auðkenninguna <0>einungis ef kóðinn</0> hér fyrir neðan er sá sami og birtist í símanum.",
			"placeholder": "Sláðu inn kennitöluna þína",
			"timeout": "Auðkenning rann út á tíma"
		}
	},
	"page-overview": {
		"incomingShipments": "Til mín",
		"outgoingShipments": "Frá mér",
		"deliveredShipments": "Sóttar sendingar",
		"noShipmentsFound": "Engar sendingar fundust",
		"noShipmentFound": "Sending fannst ekki",
		"deliveryLocation": "Afhendingarstaður",
		"homeDelivery": "Heimsent",
		"addReceipt": "Senda reikning",
		"openLocker": "Opna box",
		"inTransit": "Á leiðinni",
		"delivered": "Sóttar sendingar",
		"addDocuments": "Bæta við reikning",
		"missingCustomsInformation": "Vantar tollaupplýsingar",
		"missingDocuments": "Ekki með reikning",
		"isGift": "Er gjöf",
		"payFor": "Borga fyrir ",
		"customsInfoFor": "Bæta við tollaupplýsingum fyrir ",
		"barcode": "Strikamerki",
		"qrInstruction": "Skannaðu QR kóðann eða sláðu inn PIN.",
		"multiPartQRCode": "Skannaðu QR kóðann eða sláðu inn PIN 1 og staðfestu, sláðu svo inn PIN 2 og staðfestu.",
		"dropoffFile": "Fylgiskjal",
		"dropOff": "Komdu sendingunni til okkar",
		"dropoffAtPostoffice": "Komdu með sendinguna á næsta pósthús",
		"dropoffAtPostofficeStatus": "Sjá opnunartíma pósthúsa",
		"dropoffAtPostbox": "Skilaðu sendingunni í póstbox",
		"dropoffAtPostboxCondition": "*Til að þú getir skilað af þér sendingunni í póstbox þarf greiðslumáti að vera til staðar sem og kveikt á sjálfvirkum greiðslum -",
		"dropoffAtPostboxAutomaticCondition": "*Til að þú getir skilað af þér sendingunni í póstbox þarf að vera kveikt á sjálfvirkum greiðslum -",
		"dropoffAtPostboxStatus": "Þú getur skilað pakkanum hér",
		"dropoffStatuses": "Staða afhendingarstaða",
		"dropOffAtLocation": "Farðu með pakkann í næsta póstbox eða á pósthús.",
		"dropOffAtPostoffice": "Nú hefur þú skráð sendinguna og getur komið með hana á pósthús.",
		"barcodeInfo": "Strikamerkið er notað til að opna póstbox og/eða prenta út merkingar.",
		"barcodeInfoPostoffice": "Strikamerkið/fylgiskjalið er aðgengilegt á Mínum síðum og í appinu.",
		"printLabelAtLocation": " Límdu merkingarnar á pakkann.",
		"printLabelAtPostoffice": "Vinsamlegast póstleggðu sendinguna á pósthúsi og sýndu starfsmanni á pósthúsi fylgiskjalið útprentað eða í símanum.",
		"payment-card-missing": "Sendingin var skráð án þess að upplýsingar um greiðslukort væru vistaðar á Mínum síðum.",
		"bring-the-barcode": "Vinsamlegast póstleggðu sendinguna á pósthúsi og sýndu starfsmanni á pósthúsi fylgiskjalið útprentað eða í símanum.",
		"barcode-accessible": "Strikamerkið/fylgiskjalið er aðgengilegt á Mínum síðum og í appinu",
		"deleteShipment": "Ertu viss um að þú viljir eyða þessari sendingu?",
		"showHidden": "Sýna faldar",
		"hideHidden": "Fela faldar",
		"hideShipmentModal": "Ertu viss um að þú viljir fela sendinguna?"
	},
	"page-settings": {
		"deliveryOptions": "Afhendingarstaðir",
		"deliveryOptionsSubHeader": "Hvar viltu fá sendinguna þína afhenta?",
		"ruralInfo": "Athugaðu! Ef þú býrð í dreifbýli og vilt fá pakkann heimsendan skaltu ekki velja neitt nema þú viljir sækja á pósthús eða póstbox.",
		"chooseDeliveryOption": "Velja afhendingarstað",
		"paymentOptions": "Greiðslukort",
		"addPaymentOption": "Bæta við greiðslumáta",
		"deleteCard": "Viltu eyða kortinu?",
		"default": "Sjálfgefið",
		"location": "Staðsetning",
		"zip": "Póstnúmer",
		"municipality": "Sveitarfélag",
		"openingHours": "Opnunartímar",
		"changeProfile": "Breyta mínum prófíl",
		"changeAddress": "Breyta aðsetri",
		"changeForMyself": "Breyta fyrir mig",
		"changeFor": "Breyta fyrir ",
		"changePassword": "Breyta lykilorði",
		"oldPassword": "Gamla lykilorðið",
		"newPassword": "Nýtt lykilorð",
		"repeatNewPassword": "Endurtaka nýtt lykilorð",
		"chooseRegion": "Velja landsvæði",
		"deliveryOptionSearch": "Leita..",
		"automaticPaymentsInfo": "Flýtir fyrir afgreiðslu og þú borgar minna!",
		"enableAutomaticPayments": "Kveikja á sjálfvirkri greiðslu",
		"disableAutomaticPayments": "Slökkva á sjálfvirkri greiðslu",
		"verifyMessage": "Staðfesta eftirfarandi:",
		"verifyPhoneNumber": "Staðfesta símanúmer",
		"verifyEmail": "Staðfesta netfang",
		"verifyPhoneNumberMessage": "Við höfum sent staðfestingarkóða í sms. Skráðu inn kóðann hér fyrir neðan til að klára staðfestingu.",
		"verifyEmailMessage": "Við höfum sent þér tölvupóst á netfangið þitt með staðfestingarhlekk. Smelltu á hlekkinn til að staðfesta netfangið.",
		"verificationCode": "Staðfestingarkóði",
		"code": "Kóði",
		"verify": "Staðfesta",
		"close": "Loka",
		"clearDeliveryOption": "Hreinsa",
		"verifyEmailSecureMessage": "Við höfum sent þér tölvupóst á netfangið þitt með staðfestingarkóða. Skráðu inn kóðann hér fyrir neðan til að klára staðfestingu.",
		"verifyEmailForceHeader": "Staðfestu netfang",
		"verifyEmailForce": "Til að geta notað Mínar síður þarftu að staðfesta netfang",
		"verifyEmailSecureMessage2": "Við höfum sent þér tölvupóst á netfangið ",
		"verifyEmailSecureMessage3": " með staðfestingarkóða. Skráðu inn kóðann hér fyrir neðan til að klára staðfestingu.",
		"phone-gsm-format": "Símanúmer verður að vera farsímanúmer"
	},
	"page-recipients": {
		"info": "Þú getur notað vistaða viðtakendur til að flýta fyrir við skráningu sendinga.",
		"addRecipient": "Nýr viðtakandi",
		"editRecipient": "Breyta viðtakanda",
		"noRecipients": "Fann enga vistaða viðtakendur."
	},
	"status": {
		"AvailableForPickup": "Tilbúin til afhendingar",
		"AvailableForPickupAtParcelPoint": "Tilbúin til afhendingar í Pakka Porti",
		"AvailableForPickupAtPostBox": "Tilbúin til afhendingar í Póstboxi",
		"AvailableForPickupAtPostOffice": "Tilbúin til afhendingar í Pósthúsi",
		"Cancelled": "Hætt við",
		"Delivered": "Afhent",
		"Error": "Villa",
		"Failure": "Tókst ekki að afhenda",
		"InProgress": "Í vinnslu",
		"InTransit": "Í flutningi",
		"InvoiceReceived": "Reikningur sendur",
		"OnHold": "Í bið",
		"OutForDelivery": "Í útkeyrslu",
		"PreTransit": "Pósturinn bíður eftir sendingunni",
		"ReturnToSender": "Skilað til sendanda",
		"Unknown": "Óþekkt",
		"WaitingDropOff": "Beðið eftir sendingunni",
		"CourierPickup": "Sótt af sendli",
		"DepartedFromSender": "Sending send frá sendanda",
		"InternationalShipmentArrivedInIceland": "Sending komin til Íslands",
		"InternationalShipmentExpectedFromAbroad": "Sending væntanleg til landsins",
		"InTransitAbroad": "Í flutningi erlendis",
		"OutForHomeDelivery": "Í heimkeyrslu",
		"ReturnedToSender": "Endursend",
		"UnsuccessfulHomeDelivery": "Heimkeyrsla mistókst"
	},
	"dropOffStatus": {
		"none": "Ekkert hólf laust",
		"low": "Mjög fá laus hólf",
		"medium": "Nokkur hólf laus",
		"high": "Mikið af lausum hólfum!"
	},
	"page-files": {},
	"amount": "Upphæð",
	"availableForPickup": "Tilbúið til afhendingar",
	"fetchDocument": "Sækja",
	"filesConnectedToShipment": "Skjöl tengd sendingu",
	"paymentBreakdown": "Yfirlit gjalda",
	"paymentInfoText1": "Upplýsingar um gjöld við innflutning og tollaflokka má finna á ",
	"paymentInfoText2": "vef Skattsins",
	"paymentInfoText3": ", og í neðangreindum skjölum er að finna sundurliðun á gjöldunum.",
	"postbox": "Póstbox",
	"postboxInfo": "Póstbox eru staðsett á ýmsum lykilstöðum um allt land og eru opin 24/7",
	"pakkaport": "Pakkaport",
	"pakkaportInfo": "Þú sækir pakka í þjónustukjarna nálægt þér, þegar þér hentar.",
	"postoffice": "Pósthús",
	"postofficeInfo": "Þú sækir sendingar í pósthús að eigin vali.",
	"deliveryPointSearchPlaceholder": "Leitaðu eftir nafni, póstnúmeri, heimilisfangi..",
	"undecided": "Óákveðið",
	"homeDelivery": "Heimsent",
	"postCode": "Póstnúmer",
	"noDocuments": "Það eru engin skjöl tengd þessari sendingu",
	"unnamedFile": "Ónefnd skrá",
	"addDocuments": "Bæta við skjölum",
	"noTrackingEvents": "Það er engin sendingarsaga á þessari sendingu",
	"fullName-required": "Verður að skrá nafn",
	"socialId-required": "Kennitala er nauðsynleg",
	"socialId-min": "Kennitala er 10 stafir",
	"socialId-wrong-format": "Snið kennitölu er ekki rétt",
	"companySSN": "Þú ert með fyrirtækjakennitölu, vinsamlegast skráðu þig á <0>fyrirtaekjasidur.posturinn.is</0>",
	"invalid-socialid": "Kennitala finnst ekki á skrá, reyndu aftur",
	"backToLogin": "Til baka í innskráningu",
	"name": "Nafn",
	"fullName": "Fullt nafn",
	"automaticPayments": "Sjálfvirk greiðsla",
	"cardholder": "Nafn á korti",
	"cardholderPlaceholder": "Jón Jónsson",
	"cardnumber": "Kortanúmer",
	"cardnumberPlaceholder": "****************",
	"expiryDate": "Gildistími",
	"expiryDatePlaceholder": "mm/áá",
	"cvc": "CVC",
	"cvcPlaceholder": "***",
	"receipt": "Kvittun",
	"shipments": "Sendingar",
	"trackingNumber": "Sendingarnúmer",
	"trackingHistory": "Sendingarsaga",
	"package": "Pakki",
	"destination": "Afhendingarstaður",
	"shipmentStatus": "Staða sendingar",
	"email": "Netfang",
	"email-format": "Netfang er ekki á réttu formi",
	"email-spell-warning": "Gæti verið innsláttarvilla í netfanginu ætti það að vera {{email}}",
	"email-undeliverable": "Netfang ekki til eða ekki hægt að senda á það",
	"email-invalid": "Nefang er ekki gilt",
	"phone": "Símanúmer",
	"ssn": "Kennitala",
	"address": "Heimilisfang",
	"country": "Land",
	"search": "Leita",
	"changeAddressForPeople": "Færa einstaklinga yfir á þetta heimilisfang",
	"errorFetchingPostalCodes": "Finn ekki götu með heiti: ",
	"errorFetchingPostalCodesInfo": "Aðeins að setja götuheiti án götunúmers og ekkert bil",
	"familyMembers-one-required": "Verður að velja allaveganna einn einstakling",
	"streetNumber": "Götunúmer",
	"appartmentNumber": "Íbúðarnúmer",
	"additionalInformation": "Athugasemdir",
	"street": "Götuheiti",
	"street-required": "Verður að setja götuheiti",
	"streetNumber-required": "Verður að setja götunúmer",
	"zip-required": "Verður að setja póstfang",
	"information": "Upplýsingar",
	"hi": "Hæ ",
	"expired": "Útrunnið",
	"active": "Virkt",
	"filesAdditionalInformation": "Innihaldslýsing",
	"yes": "Já",
	"no": "Nei",
	"or": "Eða",
	"confirm": "Staðfesta",
	"submit": "Skrá",
	"send": "Senda",
	"unknown": "Óþekkt",
	"change": "Breyta",
	"more": "Nánar",
	"Click": "Smellið",
	"here": "hér",
	"priceBreakdown": "Sundurliðun",
	"pay": "Borga",
	"payWith": "Borga með",
	"total": "Samtals",
	"delete": "Eyða",
	"deleteItem": "Eyða hlut?",
	"remove": "Fjarlægja",
	"save": "Vista",
	"seeMore": "Sjá nánar",
	"seeLess": "Sjá minna",
	"enabled": "Kveikt",
	"disabled": "Slökkt",
	"viewOnMap": "Sjá á korti",
	"required": "Skylda að fylla út",
	"wrongFormat": "Vitlaust snið",
	"tooShort": "Of fáir stafir",
	"tooLong": "Of margir stafir",
	"genericError": "Eitthvað fór úrskeiðis, vinsamlegast reyndu aftur.",
	"genericRegistrationError": "Nýskráning mistókst.",
	"choose": "Velja",
	"passwordConfirmError": "Lykilorð stemma ekki",
	"passwordLengthError": "Má minnst vera 6 stafir",
	"phoneMustBe7": "Símanúmer verður að vera 7 stafir",
	"success": "Tókst",
	"genericVerificationError": "Tókst ekki að staðfesta",
	"invalidValue": "Ólöglegt gildi",
	"qrCode": "QR kóði",
	"terms": "Skilmálar",
	"acceptTerms": "Til þess að ganga frá beiðni um tollafgreiðslu þarftu að samþykkja skilmála um skýrslugerð.",
	"termsLinked": "Ég samþykki <0>skilmála um skýrslugerð</0>.",
	"availableForDropOff": "Komdu sendingunni til okkar",
	"errorFetchDocument": "Villa að sækja skjal",
	"refunds": {
		"refundAvailable": "Samkvæmt okkar kerfum, átt þú {{refundAvailable}} kr. inni hjá okkur.",
		"refundReceived": "Þú hefur fengið endurgreiðslu upp á {{refundCorrected}} kr.",
		"noRefund": "Engin endurgreiðsla til staðar.",
		"bankInfoSent": "Bankaupplýsingar mótteknar.",
		"refundExplanation1": "Því miður kom upp kerfisvilla hjá Póstinum á tímabilinu 16. nóvember 2022 til 23. febrúar 2023. Ákveðin tegund af sendingum lentu í röngum verðflokki. Þú fékkst sendingu/sendingar sem lentu í röngum verðflokki. Þú átt inni {{refundCorrected}} kr. hjá Póstinum. ",
		"refundExplanation2": "Þú getur valið á milli þess að fá upphæðina endurgreidda eða nýta hana sem inneign upp í næstu sendingu frá útlöndum. Ef þú kýst að fá hana endurgreidda skaltu fylla út formið hér fyrir neðan fyrir 1. október 2023. Að þeim tíma loknum verður inneignin nýtt upp í næstu sendingu eða sendingar til þín frá útlöndum.  ",
		"refundApology": "Okkur þykir leitt að hafa valdið þessum óþægindum og við biðjumst velvirðingar á mistökunum."
	},
	"showMore": "Sjá meira",
	"cardExpired": "Greiðslukort er útrúnnið/ógilt",
	"invalidRegTypeUS": "Ekki er hægt að skrá þessa sendingu til Bandaríkjanna að svo stöddu vegna fyrirhugaðra breytinga bandarískra stjórnvalda á tollagjöldum",
	"weight": "Þyngd"
}
